export default __webpack_public_path__ + "static/media/girl.d4fc6e6b.png";